export enum ActionType {
  EMAIL_VERIFICATION_REQUEST = 'email_verification_request',
  EMAIL_VERIFICATION_SUCCESS = 'email_verification_success',
  EMAIL_VERIFICATION_ERROR = 'email_verification_error'
}
